import { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/joy";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import { useApiKeys } from "../../hooks/useApiKeys";
import { CreateApiKeyModal, DeleteApiKeyModal } from "./modals";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const IntegrationsTab = () => {
  const { apiKeys, createApiKey, deleteApiKey } = useApiKeys();

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [keyToDelete, setKeyToDelete] = useState(null);

  const handleOpenDeleteModal = (key) => {
    setKeyToDelete(key);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setKeyToDelete(null);
    setDeleteModalOpen(false);
  };

  const renderApiKeys = () => {
    if (apiKeys.length === 0) {
      return <Typography>No API keys found.</Typography>;
    }

    return apiKeys.map((key) => (
      <Grid key={key.id} xs={12} sm={6}>
        <Card variant="outlined">
          <CardContent>
            <Typography level="title-sm" sx={{ fontWeight: "bold" }}>
              {key.name}
            </Typography>
            <Typography level="body-sm" color="neutral">
              {key.description || "No description"}
            </Typography>
            <Typography level="body-xs" color="neutral">
              Created: {formatDate(key.created_at)}
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center", mt: 1, gap: 1.5 }}
            >
              <Typography
                level="body-sm"
                sx={{ flex: 1, fontFamily: "monospace" }}
              >
                ****{key.key_suffix}
              </Typography>
              <IconButton
                onClick={() => handleOpenDeleteModal(key)}
                color="danger"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    ));
  };

  return (
    <>
      <Typography level="title-lg" fontWeight="bold" mb={2}>
        API Keys
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="soft"
          startDecorator={<AddIcon />}
          onClick={() => setCreateModalOpen(true)}
        >
          Add API Key
        </Button>
      </Box>
      <Grid container spacing={2}>
        {renderApiKeys()}
      </Grid>

      <CreateApiKeyModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onCreateApiKey={createApiKey}
      />

      <DeleteApiKeyModal
        open={deleteModalOpen}
        onClose={handleCloseDeleteModal}
        keyToDelete={keyToDelete}
        onConfirmDelete={deleteApiKey}
      />
    </>
  );
};

export default IntegrationsTab;
